var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template-select-2"},[_c('select2',{attrs:{"id":_vm.id,"options":_vm.optionsList,"value":_vm.value,"settings":_vm.settings,"disabled":_vm.disabled,"placeholder":_vm.placeholder},on:{"change":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }